<template>
  <div class="mobile-footer-container">
    <img :src="require('@/assets/images/profile/logo-white.png')" alt="logo" class="logo">

    <div class="select-edition">
      <span class="edition-title">Выбор редакции</span>
      <span class="edition-item">Регистрации грузовых автомобилей за 2 квартал 2024</span>
      <span class="edition-item">Регистрации грузовых автомобилей за 2 квартал 2024</span>
      <span class="edition-item">Продажи дизельных автомобилей</span>
      <span class="edition-item">Новость 1</span>
      <span class="edition-item">Контакты</span>
    </div>

    <div class="sections-soc-networks">
      <div class="section">
        <span class="edition-title">Разделы</span>
        <span
            v-for="(section, idx) in sections.filter(s => s.active)"
            :key="idx"
        >
          <a :href="section.url">
            {{ section.name }}
          </a>
        </span>
      </div>

      <div class="social-media">
        <div>
          <span class="social-media-title">Социальные сети</span>
          <div class="social-media-icons">
            <a
                v-for="(icon, idx) in socialMediaIcons"
                :key="idx"
                :href="icon.url"
                target="_blank"
                rel="noopener noreferrer"
            >
              <img
                  :src="icon.src"
                  :alt="icon.alt"
              >
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="privacy">
      <a href="/privacy-policy" class="edition-item">Политика конфиденциальности</a>
      <span class="certificate-info">Cвидетельство о регистрации СМИ «Автомаркетолог» Эл №ФС77-47104 от 29 октября 2011 года, зарегистрирован Федеральной службой по надзору в сфере связи, информационных технологий и массовых коммуникаций (Роскомнадзор). Возрастная классификация «18+».</span>
      <span class="certificate-info">© ООО «АВТОМАРКЕТОЛОГ», 2012-{{ currentYear }}</span>
    </div>

  </div>

</template>

<script>
import XLogo from "@/assets/images/soc_networks_dark_theme/X Logo.svg";
import YouTubeLogo from "@/assets/images/soc_networks_dark_theme/Logo Youtube.svg";
import TelegramLogo from "@/assets/images/soc_networks_dark_theme/Telegram Logo.svg";

export default {
  name: "MainFooter",
  data() {
    return {
      sections: [
        { name: 'О проекте', url: '/about', active: false },
        { name: 'СМИ', url: 'https://automarketolog.ru', active: true },
        { name: 'Аналитика', url: '/analytics', active: true },
        { name: 'Мероприятия', url: '/events', active: false },
        { name: 'Сообщество', url: '/community', active: false },
        { name: 'Партнеры', url: '/partners', active: false },
        { name: 'Контакты', url: '/contacts', active: false },
      ],
      socialMediaIcons: [
        { src: YouTubeLogo, alt: 'YouTube Logo', class: 'youtube', url: 'https://youtube.com/@automarketolog' },
        { src: TelegramLogo, alt: 'Telegram Logo', class: 'telegram', url: 'https://t.me/automarketolog_ru' },
        { src: XLogo, alt: 'X Logo', class: 'x', url: 'https://x.com/automarketolog' },
      ],
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
}
</script>

<style scoped>
.mobile-footer-container {
  background-color: rgba(35, 40, 44, 1);
  padding: 40px 20px 20px 20px;
  display: flex;
  flex-direction: column;
}

.select-edition {
  display: flex;
  flex-direction: column;
  color: rgba(255, 255, 255, 1);
  gap: 12px;
}

.edition-title {
  font-size: 16px;
  line-height: 16px;
  font-weight: 400;
}

.edition-item {
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
}

.sections-soc-networks {
  margin-top: 6px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.social-media {
  display: flex;
  flex-direction: column;
  width: 156px;
  padding: 0;
}

.social-media-icons {
  display: flex;
  gap: 20px;
}

.privacy {
  display: flex;
  flex-direction: column;
  gap: 20px;
  color: white;
}

.certificate-info {
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
}

.section {
  width: 178px;
  display: flex;
  flex-direction: column;
  color: white;
  gap: 12px;
}

</style>